export enum RoleEnum {
  AO_User = "AO_User",
  AO_Publisher = "AO_Publisher",
  WK_Editor = "WK_Editor",
  WK_Publisher = "WK_Publisher"
}
